import store from "@/store";

export default function authHeader() {
  const token = store.state.Auth.jwtToken;

  if (token) {
    return { Authorization: token };
  } else {
    return {};
  }
}
